<div class="container">
  <div class="footer-container">

    <!-- Three columns of text below the carousel -->
    <div class="landing-content">
      <div class="row">
        <div class="col-lg-4">
          <div class="image-container">
            <img class="networkneeds-image" src="assets/images/your-needs-icon.svg" alt="Generic placeholder image"
              width="64" height="64">
          </div>
          <div class="footer-content first">
            <p class="header-content">{{cfetLabels.cfet_customer_footer.header_content_first}}</p>
            <p class="txt">{{cfetLabels.cfet_customer_footer.text_first}}</p>
          </div>
        </div>
        <!-- /.col-lg-4 -->
        <div class="col-lg-4">
          <div class="image-container">
            <img class="network-image" src="assets/images/network.png" alt="Generic placeholder image" width="44"
              height="54">
          </div>
          <div class="footer-content second">
            <p class="header-content">{{cfetLabels.cfet_customer_footer.header_content_second}}</p>
            <p class="txt">{{cfetLabels.cfet_customer_footer.text_second}}</p>
          </div>
        </div>

        <!-- /.col-lg-4 -->
        <div class="col-lg-4 ">
          <div class="image-container">
            <img class="headphones-image" src="assets/images/Headphones.png" alt="Generic placeholder image" width="54"
              height="54">
          </div>
          <div class="footer-content third">
            <p class="header-content">{{cfetLabels.cfet_customer_footer.header_content_third}}</p>
            <p class="txt">{{cfetLabels.cfet_customer_footer.text_third}}</p>
          </div>
        </div>
        <!-- /.col-lg-4 -->
      </div><!-- /.row -->

      <div class="row link">
        <p>{{cfetLabels.cfet_customer_footer.learn_more}}
          <span>
            <a href="https://www.firstnet.com" target="_blank" rel="noopener noreferrer">
              <img alt="Generic placeholder image" src="assets/images/Arrow.png" /></a>
          </span>
        </p>
      </div>

    </div>

  </div>
</div>